import Vue from 'vue';
import { SHAPE, APPEARANCE, VARIANT, SIZE } from '@omnica/button';

var notEmptyText = function (node) {
    return !!node.text && node.text.trim() != '';
};
var isTextual = function (node) {
    return notEmptyText(node) || ['b', 'i', 'span', 'strong'].includes(node.tag);
};

var script$2 = Vue.extend({
    name: 'UiButtonContent',
    functional: true,
    render: function (h, _a) {
        var _b;
        var parent = _a.parent, props = _a.props;
        var node = props.node;
        var isTextNode = isTextual(node);
        if (node.isComment || (isTextNode && parent.$props.shape === SHAPE.SQUARE)) {
            return [];
        }
        return h('span', { class: (_b = {},
                _b['omnica-button__icon'] = !isTextNode,
                _b['omnica-button__text'] = isTextNode,
                _b) }, [node]);
    },
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$2 = script$2;

/* template */

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1 = Vue.extend({
    name: 'UiButtonRoot',
    functional: true,
    render: function (h, _a) {
        var data = _a.data, props = _a.props, children = _a.children;
        return h(props.href ? 'a' : 'button', data, children);
    },
});

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

var script = Vue.extend({
    name: 'UiButton',
    components: {
        UiButtonContent: __vue_component__$2,
        UiButtonRoot: __vue_component__$1,
    },
    props: {
        /** Устанавливает тип кнопки */
        type: {
            type: String,
            default: 'button',
        },
        /** Устанавливает атрибут href якоря */
        href: {
            type: String,
            default: undefined,
        },
        /** Регулирует внешний вид кнопки: primary, secondary, tertiary or outlined */
        appearance: {
            type: String,
            default: APPEARANCE.PRIMARY,
        },
        /** Регулирует цветовую схему кнопки: default, success or danger */
        variant: {
            type: String,
            default: VARIANT.DEFAULT,
        },
        /** Закругленная или прямоугольная */
        shape: {
            type: String,
            default: SHAPE.DEFAULT,
        },
        /** Размер */
        size: {
            type: String,
            default: SIZE.SM,
        },
        /** Если кнопка активна */
        active: {
            type: Boolean,
            default: false,
        },
        /** Определяет, будет ли текст обрезаться через многоточие или переноситься на следующую строку */
        ellipsis: {
            type: Boolean,
            default: true,
        },
        /** Если кнопка отключена */
        disabled: {
            type: Boolean,
            default: false,
        },
        /** Если кнопка заблокирована */
        locked: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            hasLeadingIcon: false,
            hasTrailingIcon: false,
            hasText: false,
        };
    },
    mounted: function () {
        var _this = this;
        var self = this;
        self._observer = new MutationObserver(function (mutations) {
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var mutation = mutations_1[_i];
                if (['childList', 'subtree'].includes(mutation.type)) {
                    _this.updateFlags();
                }
            }
        });
        self._observer.observe(this.$el, { childList: true, subtree: true });
        this.updateFlags();
    },
    beforeDestroy: function () {
        var self = this;
        self._observer = undefined;
    },
    methods: {
        click: function () {
            var _a;
            (_a = this.$el) === null || _a === void 0 ? void 0 : _a.click();
        },
        focus: function () {
            var _a;
            (_a = this.$el) === null || _a === void 0 ? void 0 : _a.focus();
        },
        blur: function () {
            var _a;
            (_a = this.$el) === null || _a === void 0 ? void 0 : _a.blur();
        },
        updateFlags: function () {
            var children = this.$slots.default || [];
            var types = children.map(function (node) {
                return node.isComment
                    ? 'comment'
                    : isTextual(node)
                        ? 'text'
                        : 'icon';
            });
            this.hasLeadingIcon = this.shape !== SHAPE.SQUARE && types[0] === 'icon';
            this.hasTrailingIcon = this.shape !== SHAPE.SQUARE && types[types.length - 1] === 'icon';
            this.hasText = types.some(function (t) { return t === 'text'; });
        },
    },
});

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "UiButtonRoot",
    _vm._g(
      {
        class:
          ((_obj = {}),
          (_obj["omnica-button"] = true),
          (_obj["omnica-button_" + _vm.appearance] = true),
          (_obj["omnica-button_" + _vm.size] = true),
          (_obj["omnica-button_" + _vm.shape] = true),
          (_obj["omnica-button_" + _vm.variant] = true),
          (_obj["omnica-button_has-leading-icon"] =
            _vm.hasText && _vm.hasLeadingIcon),
          (_obj["omnica-button_has-trailing-icon"] =
            _vm.hasText && _vm.hasTrailingIcon),
          (_obj["omnica-button_active"] = _vm.active),
          (_obj["omnica-button_disabled"] = _vm.disabled),
          (_obj["omnica-button_ellipsis"] = _vm.ellipsis),
          (_obj["omnica-button_locked"] = _vm.locked),
          _obj),
        attrs: {
          type: !_vm.href ? _vm.type : null,
          href: _vm.href,
          disabled: _vm.disabled || _vm.locked,
        },
      },
      _vm.$listeners
    ),
    [
      _c(
        "span",
        { staticClass: "omnica-button__inner" },
        _vm._l(_vm.$slots.default, function (node, index) {
          return _c("UiButtonContent", { key: index, attrs: { node: node } })
        }),
        1
      ),
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
